module.exports = __webpack_public_path__ + "static/media/pending.172de6bc.svg";